import {
  getActivityGroupDetails,
} from "../../services";

export const SET_WORKERS = "SET_WORKERS";
export const ADD_NEW_WORKER = "ADD_NEW_WORKER";
export const DELETE_WORKER = "DELETE_WORKER";
export const SET_WORKERS_FOR = "SET_WORKERS_FOR";
export const ADD_NEW_WORKER_FOR = "ADD_NEW_WORKER_FOR";
export const DELETE_WORKER_FOR = "DELETE_WORKER_FOR";

/**
 * fn to set all workers.
 * @param {Array} array of worker objects.
 * @return: {Object} action object
 */
export const setAllMyWorkers = (payload) => ({
  type: SET_WORKERS,
  payload,
});
export const setAllWorkersFor = (payload) => ({
  type: SET_WORKERS_FOR,
  payload,
});


/**
 * fn for fetching activity group details.
 * @param {string}
 * @return: {Object} containing activity group details
 */
export const getDemoData = () => (dispatch) => {
  console.log("in workerActions: getDemoData...");
  getActivityGroupDetails().then((data) => {
    if (data) {
      const activityGroups = data;
      // dispatch(getActivityGroupSuccess(activityGroups));
    }
  });
};

/**
 * fn for fetching locationDev building details.
 * @param {string}
 * @return: {Object} containing building details for each district.
 */
export const getSomeData = (country) => (dispatch) => {
  console.log("in workerActions: getSomeData...");
  // getLocationDevDetails(country).then((data) => {
  //   if (data) {
  //     dispatch(loadLocationsDSC(data));
  //   }
  // });
};

export const demo1 = (payload) => ({
  type: "DEMO1",
  payload,
});
